export default "__VITE_ASSET__CKToZEyX__"